/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Faq_A1Inputs */

const en_pc_faq_a1 = /** @type {(inputs: Pc_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. PdfCraft is free and open source under the MIT or Apache-2.0 license on every platform. There is no paid tier, no trial period and no account to create.`)
};

const zh_pc_faq_a1 = /** @type {(inputs: Pc_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是的。PdfCraft 在所有平台上都免费，并以 MIT 或 Apache-2.0 许可证开源。没有付费版本，没有试用期，也不需要注册账号。`)
};

/**
* | output |
* | --- |
* | "Yes. PdfCraft is free and open source under the MIT or Apache-2.0 license on every platform. There is no paid tier, no trial period and no account to create." |
*
* @param {Pc_Faq_A1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_faq_a1 = /** @type {((inputs?: Pc_Faq_A1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Faq_A1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_faq_a1(inputs)
	return zh_pc_faq_a1(inputs)
});
export { pc_faq_a1 as "pc.faq.a1" }